export const BAR_WIDTH = 150;
export const MAX_BARS = 5;
export const DAILY_COMPARISON_MAX_BARS = 11;
export const SCROLL_HEIGHT = 10;
export const MARGIN_BOTTOM_PDF = '80px';
export const MARGIN_BOTTOM = '30px';
export const GRAPH_HEIGHT = 395;
export const PDF_GRAPH_HEIGHT = 247;
